import { useEffect, useState } from "react";
import { toast } from "sonner";
import { api, formatApiError } from "@/lib/api";
import { CATEGORIES } from "@/lib/store";

const FIELDS = [["weight", "Peso (kg)"], ["length", "Comp. (cm)"], ["width", "Larg. (cm)"], ["height", "Alt. (cm)"]];
const cell = "w-full min-w-0 rounded-lg border border-white/10 bg-white/5 px-2 py-1.5 text-right text-sm text-white outline-none focus:border-white/40";
const toNum = (v) => Number(String(v).replace(",", ".")) || 0;

// Pacote de cada categoria (aparelho já embalado) usado no cálculo do frete. Vários itens no carrinho somam os pacotes.
export const FreightPackages = () => {
  const [packages, setPackages] = useState(null);
  useEffect(() => {
    api.get("/admin/freight-packages").then((r) => setPackages(r?.data?.packages ?? null)).catch(() => setPackages(null));
  }, []);
  if (!packages) return null;
  const set = (cat, k, v) => setPackages((p) => ({ ...p, [cat]: { ...p[cat], [k]: v.replace(/[^\d,.]/g, "").slice(0, 6) } }));
  const save = async () => {
    try {
      const body = { packages: Object.fromEntries(Object.entries(packages).map(([c, v]) => [c, Object.fromEntries(FIELDS.map(([k]) => [k, toNum(v[k])]))])) };
      const { data } = await api.put("/admin/freight-packages", body);
      setPackages(data?.packages ?? packages);
      toast.success("Pacotes do frete salvos");
    } catch (e) {
      toast.error(formatApiError(e));
    }
  };
  return (
    <div data-testid="admin-freight-packages" className="mt-6 border-t border-white/10 pt-5">
      <p className="text-sm font-semibold text-white">Pacote para o frete</p>
      <p className="mt-1 text-xs text-zinc-400">Peso e medidas da caixa já embalada de cada tipo de produto. Com mais de um item, o frete considera todos juntos.</p>
      <div className="mt-3 overflow-x-auto">
        <table className="w-full min-w-[520px] text-sm">
          <thead><tr className="text-xs text-zinc-400">
            <th className="py-1 text-left font-medium">Produto</th>
            {FIELDS.map(([k, l]) => <th key={k} className="px-1 py-1 text-right font-medium">{l}</th>)}
          </tr></thead>
          <tbody>
            {CATEGORIES.filter((c) => packages[c.id]).map((c) => (
              <tr key={c.id}>
                <td className="py-1 pr-2 text-zinc-200">{c.label}</td>
                {FIELDS.map(([k]) => (
                  <td key={k} className="px-1 py-1"><input data-testid={`freight-pkg-${c.id}-${k}`} inputMode="decimal" value={packages[c.id][k]} onChange={(e) => set(c.id, k, e.target.value)} className={cell} /></td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <button type="button" data-testid="freight-pkg-save" onClick={save} className="mt-3 rounded-full border border-white/20 px-5 py-2 text-sm font-semibold text-white transition-colors hover:bg-white hover:text-black">Salvar pacotes</button>
    </div>
  );
};
